module.exports = __webpack_public_path__ + "static/the-outsider-13c90a5d5edd0c4131d87312634bafa2.jpg";